import {getErrorStack} from '@Utils/debug.util';

export enum PromiseStatus {
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected',
}

/**
 * A generic error handler that opens an error modal with a generic error message and sends the error log to the server.
 * @param error - The error object
 * @param message
 */
export const onAjaxError = (error: unknown, message?: string, logError = false): void => {
  window.PMW.openErrorModal({
    message: message ?? window.i18next.t('pmwjs_error_message'),
    log: logError,
    debugStack: getErrorStack(error),
  });
  console.error(error);
};

export const hasAjaxRequestBeenMade = (ajaxRequest: string): boolean => {
  initFiredAjaxRequestStorage();

  if (typeof window.firedAjaxRequests[ajaxRequest] !== 'undefined' && window.firedAjaxRequests[ajaxRequest]) {
    return true;
  }

  return false;
};

export const recordAjaxRequest = (ajaxRequest: string): void => {
  initFiredAjaxRequestStorage();
  window.firedAjaxRequests[ajaxRequest] = true;
};

export const removeRecordedAjaxRequest = (ajaxRequest: string): void => {
  initFiredAjaxRequestStorage();
  window.firedAjaxRequests[ajaxRequest] = false;
};

const initFiredAjaxRequestStorage = (): void => {
  if (typeof window.firedAjaxRequests === 'undefined') {
    window.firedAjaxRequests = {};
  }
};

export interface AjaxSuccessResponse {
  status: 'success' | 'fail' | 'error';
  data: any;
}

export interface AjaxResponse {
  error?: AjaxError;
  data?: any;
  code?: string;
  meta?: {
    requestId: string;
  };
}

export interface AjaxError {
  error: {
    name: string;
    message: string;
    stack: string;
  };
}

/** The `code` the backend attached to a failed request, when the thrown error carries one. */
export const getAjaxErrorCode = (error: unknown): string | undefined => {
  if (typeof error !== 'object' || error === null || !('code' in error)) {
    return undefined;
  }
  return typeof error.code === 'string' ? error.code : undefined;
};
